import React from 'react';
import Table from '../../common/TableTechnical';
import { connect } from 'react-redux';
import { REDUCER_NAME, changeSortState } from '../reducer';
import Const from './Const';

const getDataFromRedux = state =>
  state[REDUCER_NAME].listObjectDataTopNewHighByTicker;

function TableTechnical(props) {
  const { listId, isLoading, sortState, changeSortState } = props;

  return (
    <Table
      sortState={sortState}
      changeSortState={changeSortState}
      listId={listId}
      isLoading={isLoading}
      getDataFromRedux={getDataFromRedux}
      hideColumns={Const.listHideColumn}
      listColumns={Const.listColumn}
      i18nTitleKey="topBreakout.technical.technicalHeader"
    />
  );
}

const mapStateToProps = state => {
  return {
    listId: state[REDUCER_NAME].listDataTopNewHighTicker,
    isLoading: state[REDUCER_NAME].isLoading,
    sortState: state[REDUCER_NAME].sortState,
  };
};

const mapDispatchToProps = {
  changeSortState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableTechnical);
